

const PreviewBanner = (props) => {
  const {
    titleBanner, textBanner, closable, imageBanner,
    backgroundColor, sizeBox, linkLabel, buttonDeeplinkingLabel,
    buttonActionLabel, primaryCTAtype
  } = props.values;

  const getButtonLabel = () => {
    if(primaryCTAtype === 'DL') {
      return buttonDeeplinkingLabel
    } else if(primaryCTAtype === 'ACTION') {
      return buttonActionLabel
    } else {
      return linkLabel
    }
  }
  const buttonLabel = getButtonLabel()

  const renderText = () => {
    if (textBanner) {
      let updatedText = textBanner || '';
      const truncatedText = updatedText.length > 65 ? `${updatedText.substring(0, 65)}...` : updatedText;
      return <p dangerouslySetInnerHTML={{__html: truncatedText}}></p>;
    }
    return null;
  };

  return (
    <>
      <div className={`banner-container ${backgroundColor} ${sizeBox}`}>
        {
          closable && (
            <div className="close-icon-container">
              <i className="nexi-icon-close"></i>
            </div>
          )
        }
        <div className='banner-content'>
          <div className={`banner-text ${!imageBanner ? 'withoutImg' : ''}`}>
            { titleBanner && <h1 dangerouslySetInnerHTML={{__html: props.values.titleBanner}}></h1>}
            {renderText()}
          </div>
          { imageBanner ? (
            <div className='banner-image'>
              <img className="img" src={imageBanner} />
            </div>
            ) : null
          }
        </div>
        { buttonLabel &&
          <a className='anchor banner-link'>
            {buttonLabel}
            <i className="portal-icon-arrow-right" />
          </a>
        }
      </div>
    </>
  )
};
export default PreviewBanner;